import { useEffect, useState } from 'react';

const STORAGE_KEY = 'layout.sideBarCollapsed';

const readInitial = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

const EVENT_NAME = 'layout:sideBarCollapsed:change';

let currentValue = readInitial();

const setValue = (next: boolean) => {
  if (currentValue === next) {
    return;
  }
  currentValue = next;
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(next));
    } catch {
      // 忽略隐私模式等 localStorage 写入失败
    }
    window.dispatchEvent(new CustomEvent(EVENT_NAME));
  }
};

export const useSideBarCollapse = () => {
  const [collapsed, setCollapsedState] = useState<boolean>(currentValue);

  useEffect(() => {
    const onChange = () => setCollapsedState(currentValue);
    window.addEventListener(EVENT_NAME, onChange);
    return () => {
      window.removeEventListener(EVENT_NAME, onChange);
    };
  }, []);

  return {
    collapsed,
    toggle: () => setValue(!currentValue),
    setCollapsed: setValue,
  };
};
